export default function MaintenancePage() {
  return (
    <main style={{ minHeight: "100vh", display: "grid", placeItems: "center", padding: "clamp(16px, 6vw, 32px)" }}>
      <section style={{ textAlign: "center", maxWidth: 480 }}>
        <h1 className="mono" style={{ letterSpacing: "0.18em", textTransform: "uppercase" }}>Maintenance</h1>
        <p className="small" style={{ textTransform: "none", color: "var(--muted)" }}>
          We are upgrading the grimoire. Try again in a few minutes.
        </p>
      </section>
    </main>
  )
}
